import { motion } from 'framer-motion';
import { ReactComponent as GhostLogo } from '../../../assets/logo-4.svg';

interface FloatingMascotProps {
  size?: 'sm' | 'md' | 'lg';
}

const sizeMap = {
  sm: 40,
  md: 56,
  lg: 72,
};

function FloatingMascot({ size = 'md' }: FloatingMascotProps) {
  const px = sizeMap[size];

  return (
    <motion.div
      style={{ width: px, height: px, flexShrink: 0 }}
      animate={{ y: [0, 3, 0] }}
      transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
    >
      <GhostLogo style={{ width: '100%', height: '100%' }} />
    </motion.div>
  );
}

export default FloatingMascot;
